module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": function($event) {
        return $event.stopPropagation()
      }
    }
  }, [_c('span', {
    staticClass: "lupa glyphicon glyphicon-search"
  }), _c('span', {
    staticClass: "remove glyphicon glyphicon-remove",
    on: {
      "click": _vm.clearInput
    }
  }), _c('v-autocomplete', {
    ref: "tag_autocomplete",
    attrs: {
      "id": _vm.id,
      "items": _vm.tags,
      "component-item": _vm.template,
      "input-attrs": _vm.attrs,
      "keep-open": _vm.show_tags,
      "auto-select-one-item": false,
      "getLabel": _vm.getLabel
    },
    on: {
      "change": _vm.filterTags,
      "item-clicked": _vm.itemClicked
    },
    model: {
      value: (_vm.tag),
      callback: function($$v) {
        _vm.tag = $$v
      },
      expression: "tag"
    }
  }), _c('hr', {
    staticClass: "full"
  }), (_vm.tags.length == 0) ? _c('div', {
    staticClass: "tag-actions-buttons"
  }, [_c('span', [_vm._v("Nenhuma tag foi encontrada")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1500de32!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/autocomplete/filter_tags.vue
// module id = 1023
// module chunks = 1